import script from "./MetaNode.vue?vue&type=script&setup=true&lang=js"
export * from "./MetaNode.vue?vue&type=script&setup=true&lang=js"

import "./MetaNode.vue?vue&type=style&index=0&id=5ca5a135&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/wk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca5a135"]])

export default __exports__